import actions from './actions'
import error from './error'
import general from './general'
import meta from './meta'
import navigation from './navigation'
import validation from './validation'
import auth from './auth'
import admin from './admin'
import entities from './entities'
import imports from './imports'
import dashboard from './dashboard'
import schema from './schema'
import users from './users'
import filters from './filters'
import audit from './audit'

export default {
    actions,
    general,
    error,
    meta,
    navigation,
    validation,
    auth,
    admin,
    entities,
    imports,
    dashboard,
    schema,
    users,
    filters,
    audit,
}
